// extracted by mini-css-extract-plugin
export default {"p":"TestAndCompetitions_p__LEbFA","displayed":"TestAndCompetitions_displayed__8EDXx"};